import { DefaultTheme } from 'styled-components';
import { customColors, defaultColors, semanticColors, brandColors, greyColors } from './colours';
import { lights } from './tints';
import { typography } from './typography';
import { spaces } from './spaces';

const flyNav = {
  itemMobileHeight: '80px',
  itemHeight: '60px',
  basePadding: 29,
  levelPadding: 10, // for nested indentation
};

const menu = {
  background: '#fff',
  secondaryBackground: '#2F2F2F',
  tertiaryBackground: '#606060',
  borderColor: 'rgba(216, 216, 216, 0.2)',
};

export const defaultTheme: Omit<
  DefaultTheme,
  | 'primaryBrandColour'
  | 'secondaryBrandColour'
  | 'tertiaryBrandColour'
  | 'primaryColour'
  | 'secondaryColour'
  | 'tertiaryColour'
  | 'navigationFooterColour'
  | 'headerColour'
  | 'sectionTitleColour'
  | 'styledBootstrapGrid'
> = {
  customColors,
  defaultColors,
  semanticColors,
  greyColors,
  brandColors,
  tints: lights,
  flyNav,
  menu,
  // checkbox colors
  borderColor: '#000',
  inputRadius: '3px',
  transitionTime: '0.25s',
  transitionType: 'ease',
  activeColor: '#000',
  navbarHeight: '40px',
  headerFont: 'Playfair',
  bodyFont: 'Open sans',
  bodyFontSize: '16px',
  fontWeights: {
    normal: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
  },
  typography,
  spaces,
};
